import { z } from 'zod';
import { isInternationalCountry } from '../../../../additionals/vehicle-request/steps/vehicle-garage/additionals-garage-form-content';

export const vehicleGarageSchema = z
  .object({
    countryCode: z
      .string()
      .refine((val) => val !== '-1' && !!val, 'Please select a country'),
    addressLine1: z.string().nullable(),
    addressLine2: z.string().nullable(),
    city: z.string().nullable(),
    stateCode: z
      .string()
      .refine((val) => val !== '-1' && !!val, 'Please select a state'),
    zipCode: z.string().min(1, 'Please enter a zip code'),
    usedForTowing: z.string().min(1, 'Please select an option'),
    useSameSin: z.string().min(1, 'Please select an option'),
    towingWeight:  z.coerce.number(),
    towingWeightUnit: z.string().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.usedForTowing === 'yes') {
      if (!data.towingWeight) {
        ctx.addIssue({
          message: 'Please enter a towing weight',
          code: z.ZodIssueCode.custom,
          path: ['towingWeight'],
        });
      }
      
      if(data.towingWeight < 0){
        ctx.addIssue({
          message: 'Please enter value greater than 0',
          code: z.ZodIssueCode.custom,
          path: ['towingWeight'],
        });
      }
    }

    if (
      !data.countryCode ||
      !isInternationalCountry(data.countryCode) ||
      data.countryCode === 'Select Country'
    ) {
      const usZipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
      if (!usZipRegex.test(data.zipCode)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Please enter a valid zip code',
          path: ['zipCode'],
        });
      }
    }
  });
